import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from '../account/user.model';
import { an } from '@fullcalendar/core/internal-common';
import { Observable, forkJoin, map } from 'rxjs';
import { ResultRecharge } from '../pages/model/resultRecharge';



@Injectable({
  providedIn: 'root'
})
export class HistoriqueService {

  request: any;
  apiBaseUrl: string;

 constructor(private http: HttpClient) {
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const subscriber = JSON.parse(localStorage.getItem('subscriber') || 'null');

  if (!subscriber || !user) {
    console.warn('User or subscriber not found in localStorage');
    return; // or redirect to login
  }

  this.request = {
    identifiant: subscriber['identifiant'],
    idUser: subscriber['idUser'],
    EtablissementCode: subscriber['etablissementCode'],
    CanalCode: subscriber['canalCode'],
    typeUser: user['idPorteur']
  };
}
   RepartitionPlafondPS(model) {
    return this.http.post(environment.api_url + '/api/Cartes/RepartitionPlafondPS', model);
  }
   GetClientWithSoldee(idClient) {
    return this.http.get(environment.api_url + '/api/Client/GetClientWithSolde/' + idClient);
  }
    GetAllActivePSCarteByClient(idClient) {
    return this.http.get(environment.api_url + '/api/Cartes/GetAllActivePSCarteByClient/' + idClient);
  }
  GetHistoriqueFacturesPs(idClient: string, dateDebut?: string, dateFin?: string, status?: string,type?: string, pageNumber?: number,
     pageSize?: number,filterValue? : string): Observable<any> 
     {
    let params = new HttpParams().set('clientId', idClient);
    if (dateDebut) {
      params = params.set('dateDebut', dateDebut);
    }
    if (dateFin) {
      params = params.set('dateFin', dateFin);
    }
    if (status) {
      params = params.set('status', status);
    }
    if (type) {
      params = params.set('type', type);
    }
    if (pageNumber) {
      params = params.set('pageNumber', pageNumber.toString());
    }
    if (pageSize) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (filterValue){
      params = params.set('filterValue', filterValue);
    }
    return this.http.get(environment.api_url + '/api/Client/GetHistoriqueFactures', { params });
  }
  getlistficher (model) {
    return this.http.post(environment.api_url + '/api/BonDatas', model);
  }
  getimage (NumBon) {
    return this.http.get(environment.api_url + '/api/BonDatas/Getimage/'+ NumBon);
  }
  getFileEtat(model){
    return this.http.post(environment.api_url + '/api/BonDatas/GetFileEtat', model);
  }
  cardsetting(model): Observable<any[]>{
    var zone = this.http.post(environment.api_url + '/api/Subscriber/ZoneGeographiques', model);
    var ProduitsGroupedByFamillle = this.http.post(environment.api_url + '/api/Subscriber/GetProduitsGroupedByFamillle', model);
    var holidays = this.http.post(environment.api_url + '/api/Subscriber/Holidays', model);
    var stations = this.http.post(environment.api_url + '/api/Subscriber/Stations', model);
    return forkJoin([zone, ProduitsGroupedByFamillle, holidays, stations]);
  }
  transfertPP(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/TransfertPP', model);
  }
  transfertPS(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/TransfertPS', model);
  }
  initClickToPayTransactions(dto: any) : Observable<any> {
    return this.http.post(environment.api_url +'/api/ClickToPay/InitClickToPayPayment', dto);
  }
   ConfirmClickToPayPayment(dto: any) {
    return this.http.post(environment.api_url +'/api/RechargeClient/confirmerRechargeClikToPay', dto);
  }
  getHolderDetails() {
    return this.http.post(environment.api_url + '/api/Subscriber/Get_Subscriber_cardinfo', this.request);
  }
  CheckRecharge(idclient:string,typeCompte:string):Observable<any> {
    return this.http.post(environment.api_url + '/api/RechargeClient/CheckRecharge/'+idclient+'/'+typeCompte, null);
  }
  getHolderDetailsById(model) {
    return this.http.post(environment.api_url + '/api/Subscriber/Get_Subscriber_cardinfo', model);
  }
  getListHolders() {

    return this.http.post(environment.api_url + '/api/Subscriber/Get_Subscriber_HoldersList', this.request);
  }
  historyConsultation(model) {
    return this.http.post(environment.api_url + '/api/History/History_Consultation', model);
  }
  GetLogTransactionRecharge(model) {
    return this.http.post<any>(environment.api_url + '/api/History/GetLogTransactionRecharge', model);
  }
  GetLogTransaction(model) {
    return this.http.post(environment.api_url + '/api/History/GetTransaction/Portail', model);
  }
  GetLogRecharge(model) {
    return this.http.post(environment.api_url + '/api/History/GetLogRecharge', model).pipe(map(resp => {
      return resp;
    }));
  }
  listPorteurByIdClient(idClient: any) {
    return this.http.get(environment.api_url + '/api/Porteur/' + idClient);
  }

  GetCardsForRecharge(idClient: any) {
    return this.http.get(environment.api_url + '/api/RechargeClient/GetCardsForRecharge/' + idClient);
  }
   rechargerEnMassCarte(model) {
    return this.http.post(environment.api_url + '/api/SoldeCartes/rechargerEnMassCarte', model);
  }

  listCartes(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Get_Subscriber_CardsListe', model);
  }
  ListCartesFilter(model: any) {
    return this.http.post(environment.api_url + '/api/Cartes/filtreCarte', model);
  }
  ActivateDesactivateCard(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Activate_Desactivate', model);
  }

  CarteInfo(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Get_Subscriber_cardinfo', model);
  }
  updatephoto(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Update_Subscriber_Picture', model);
  }


  UpdatePassWord(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Update_Subscriber_PWD', model);
  }


  UpdatePassWordIdentity(model: any) {
    return this.http.post(environment.api_url + '/api/Account/ChangePassword', model);
  }


  getListePorteursActifs(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/GetHolders', model);
  }

  getListePorteursInActifs(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/GetHolders', model);
  }

  getListePorteursNonAssigne(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/GetHolders', model);
  }


  getMobileWebAccess(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/MobileWebAccess', model);
  }

  getAddHolder(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/AddHolder', model);
  }


  ConfigCard(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/UpdateCard', model);
  }

  GetCardInfoByNum(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/GetCardInfoByNum', model);
  } 

  getJourFerie(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Holidays', model);
  } 

  getAllstations(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Stations', model);
  } 

  getAllHolidays(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Holidays', model);
  }  
  
  getAllZoneGeo(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/ZoneGeographiques', model);
  }  



  getProduitsGroupedByFamillle(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/GetProduitsGroupedByFamillle', model);
  } 
  

  getZoneGeographiques(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/ZoneGeographiques', model);
  } 

  getDetailCardsListe(model: any) {
    return this.http.post(environment.api_url + '/api/Subscriber/Get_Subscriber_CardsListe', model);
  } 

  


}
